var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-footer"}},[_c('div',{staticClass:"footer-main"},[_c('div',{staticClass:"footer-item"},[_c('div',[_vm._v("本站已苟活 "+_vm._s(_vm.runTimeInterval))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }